import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GATEWAY_URL } from '../constants';
import { ContainerFileDto, InboundFaxDto, InboundFaxUpdateRequest, RestrictionDto } from '../model';

@Injectable()
export class InboundFaxApiService {
  private readonly http = inject(HttpClient);
  private readonly gatewayUrl = inject(GATEWAY_URL);

  public updateArchive(inboundFaxId: string, request: InboundFaxUpdateRequest): Observable<InboundFaxDto> {
    return this.http.patch<InboundFaxDto>(`${this.getBaseUrl()}/${inboundFaxId}/updateArchive`, request);
  }

  public updateFolder(inboundFaxId: string, request: InboundFaxUpdateRequest): Observable<InboundFaxDto> {
    return this.http.patch<InboundFaxDto>(`${this.getBaseUrl()}/${inboundFaxId}/updateFolder`, request);
  }

  public updateMember(inboundFaxId: string, request: InboundFaxUpdateRequest): Observable<InboundFaxDto> {
    return this.http.patch<InboundFaxDto>(`${this.getBaseUrl()}/${inboundFaxId}/updateMember`, request);
  }

  public updateRequestType(inboundFaxId: string, request: InboundFaxUpdateRequest): Observable<InboundFaxDto> {
    return this.http.patch<InboundFaxDto>(`${this.getBaseUrl()}/${inboundFaxId}/updateRequestType`, request);
  }

  public updateStatus(inboundFaxId: string, request: InboundFaxUpdateRequest): Observable<InboundFaxDto> {
    return this.http.patch<InboundFaxDto>(`${this.getBaseUrl()}/${inboundFaxId}/updateStatus`, request);
  }

  public updateUser(inboundFaxId: string, request: InboundFaxUpdateRequest): Observable<InboundFaxDto> {
    return this.http.patch<InboundFaxDto>(`${this.getBaseUrl()}/${inboundFaxId}/updateUser`, request);
  }

  public updateInbox(inboxId: string, inboundFaxId: string): Observable<InboundFaxDto> {
    return this.http.put<InboundFaxDto>(
      `${this.getBaseUrl()}/MoveFaxInbox/inbox/${inboxId}/inboundfax/${inboundFaxId}`,
      null
    );
  }

  public getFaxFile(inboundFaxId: string): Observable<ContainerFileDto> {
    return this.http.get<ContainerFileDto>(`${this.getBaseUrl()}/${inboundFaxId}/getFaxFile`);
  }

  public getBenefitPlanRestrictions(memberId: string): Observable<RestrictionDto> {
    return this.http.get<RestrictionDto>(`${this.getBaseUrl()}/benefitPlanRestriction/member/${memberId}`);
  }

  private getBaseUrl(): string {
    return `${this.gatewayUrl}/api/IFA/InboundFax`;
  }
}
